import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { KanbanSquare, ArrowUpRight } from "lucide-react";
import { api } from "../../lib/api";

const COLS = [["backlog", "Backlog"], ["todo", "Por hacer"], ["in_progress", "En curso"], ["review", "Revisión"], ["done", "Hecho"]];
const STUDIO = { gout: { label: "GOÛT", color: "#6D28D9" }, tagma: { label: "Tagma", color: "#DB2777" } };
const PRIO = { low: "bg-navy/10 text-navy/50", medium: "bg-gold/15 text-gold", high: "bg-rose-500/10 text-rose-600" };

export default function MyTasksBoard() {
  const [tasks, setTasks] = useState([]);
  const [mine, setMine] = useState(true);

  const load = useCallback(() => {
    api.get(`/studio/my-tasks?mine=${mine ? 1 : 0}`).then((r) => setTasks(r.data)).catch(() => {});
  }, [mine]);
  useEffect(() => { load(); }, [load]);

  const move = async (t, status) => {
    try { await api.patch(`/studio/${t.studio}/tasks/${t.id}`, { status }); load(); } catch (e) {}
  };

  return (
    <div className="bg-white border border-navy/10 rounded-lg p-6" data-testid="hub-mytasks">
      <div className="flex items-center justify-between mb-5 flex-wrap gap-3">
        <div className="flex items-center gap-2 text-navy/70"><KanbanSquare className="w-4 h-4" /><span className="overline text-navy/40">Tablero de tareas</span></div>
        <div className="flex items-center rounded-full border border-navy/15 overflow-hidden text-xs">
          {[[true, "Mis tareas"], [false, "Todas"]].map(([v, l]) => (
            <button key={l} data-testid={`mytasks-filter-${v ? "mine" : "all"}`} onClick={() => setMine(v)}
              className={`px-3 py-1.5 transition-colors ${mine === v ? "bg-navy text-cream" : "text-navy/50 hover:text-navy"}`}>{l}</button>
          ))}
        </div>
      </div>

      {tasks.length === 0 ? (
        <p className="text-sm text-navy/35 py-6 text-center" data-testid="mytasks-empty">
          {mine ? "No tienes tareas asignadas. Asígnate tareas desde el tablero de un proyecto GOÛT o Tagma." : "Aún no hay tareas en tus proyectos."}
        </p>
      ) : (
        <div className="grid md:grid-cols-5 gap-3">
          {COLS.map(([st, lbl]) => {
            const items = tasks.filter((t) => t.status === st);
            return (
              <div key={st} data-testid={`mytasks-col-${st}`} className="bg-navy/[0.03] rounded-lg p-3 min-h-[80px]">
                <div className="flex items-center justify-between mb-2"><span className="text-xs font-medium text-navy/60">{lbl}</span><span className="text-xs text-navy/30">{items.length}</span></div>
                <div className="space-y-2">
                  {items.map((t) => {
                    const s = STUDIO[t.studio] || { label: t.studio, color: "#888" };
                    return (
                      <div key={t.id} data-testid={`mytask-${t.id}`} className="bg-white border border-navy/10 rounded-lg p-3">
                        <div className="text-sm leading-snug">{t.title}</div>
                        <Link to={`/os/${t.studio}/${t.project_id}`} className="mt-2 inline-flex items-center gap-1 text-[11px] text-navy/50 hover:text-violet transition-colors">
                          <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.color }} />{s.label} · {t.project_name}<ArrowUpRight className="w-3 h-3" />
                        </Link>
                        <div className="mt-2 flex items-center gap-1.5">
                          {t.priority && <span className={`text-[10px] px-2 py-0.5 rounded-full ${PRIO[t.priority]}`}>{t.priority}</span>}
                          {t.due_date && <span className="text-[10px] text-navy/40">{t.due_date}</span>}
                        </div>
                        <select data-testid={`mytask-move-${t.id}`} value={t.status} onChange={(e) => move(t, e.target.value)} className="mt-2 w-full text-[11px] bg-cream border border-navy/10 rounded px-1.5 py-1 outline-none">
                          {COLS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                        </select>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
